<ct-lib-modal
  #modal
  [medium]="true"
  [footer]="invoiceBillingFooter"
  [closeable]="!busy()"
  [label]="
    'company-tool.views.settings.company.payment.invoice-billing.title'
      | transloco
  "
  (onClose)="onModalClosed()"
>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <p class="intro">
      {{
        'company-tool.views.settings.company.payment.invoice-billing.intro'
          | transloco
      }}
    </p>

    <div class="form-group form-floating" [class.invalid]="!!emailError()">
      <input
        id="invoiceBillingEmail"
        type="email"
        class="form-control"
        formControlName="email"
        autocomplete="email"
        placeholder=" "
        [attr.aria-invalid]="!!emailError()"
        [attr.aria-describedby]="
          emailError() ? 'invoiceBillingEmailError' : null
        "
      />
      <label for="invoiceBillingEmail">
        {{
          'company-tool.views.settings.company.payment.invoice-billing.email'
            | transloco
        }}
      </label>
      <div class="validation" id="invoiceBillingEmailError">
        <p>{{ emailError() | transloco }}</p>
      </div>
    </div>

    <div class="form-group form-floating">
      <input
        id="invoiceBillingName"
        type="text"
        class="form-control"
        formControlName="name"
        autocomplete="organization"
        placeholder=" "
      />
      <label for="invoiceBillingName">
        {{
          'company-tool.views.settings.company.payment.invoice-billing.name'
            | transloco
        }}
      </label>
    </div>

    <div class="form-group" [class.invalid]="!!addressError()">
      <app-location-input
        [control]="form.controls.hereId"
        [submitAttempt]="submitAttempt()"
        [label]="addressLabel()"
        [requireComplete]="true"
        [placeholder]="
          'company-tool.views.settings.company.payment.invoice-billing.address'
            | transloco
        "
        [notFoundText]="
          'company-tool.views.settings.company.payment.invoice-billing.address-not-found'
            | transloco
        "
        (locationChange)="onLocationChange($event)"
      ></app-location-input>
      @if (!addressError()) {
        <p class="address-hint" id="invoiceBillingAddressHint">
          {{
            'company-tool.views.settings.company.payment.invoice-billing.address-hint'
              | transloco
          }}
        </p>
      }
      <div class="validation" id="invoiceBillingAddressError">
        <p>{{ addressError() | transloco }}</p>
      </div>
    </div>

    <div class="form-group form-floating">
      <input
        id="invoiceBillingAddressLine2"
        type="text"
        class="form-control"
        formControlName="addressLine2"
        autocomplete="address-line2"
        placeholder=" "
      />
      <label for="invoiceBillingAddressLine2">
        {{
          'company-tool.views.settings.company.payment.invoice-billing.address-line2'
            | transloco
        }}
      </label>
    </div>

    <div
      class="form-group form-floating tax-id"
      [class.invalid]="!!taxIdError()"
    >
      <input
        id="invoiceBillingTaxId"
        type="text"
        class="form-control"
        formControlName="taxId"
        autocomplete="off"
        autocapitalize="characters"
        spellcheck="false"
        placeholder="DE123456789"
        [attr.aria-invalid]="!!taxIdError()"
        [attr.aria-describedby]="
          taxIdError() ? 'invoiceBillingTaxIdError' : null
        "
      />
      <label for="invoiceBillingTaxId">
        {{
          'company-tool.views.settings.company.payment.invoice-billing.tax-id'
            | transloco
        }}
      </label>
      <div class="validation" id="invoiceBillingTaxIdError">
        <p>{{ taxIdError() | transloco }}</p>
      </div>
    </div>

    @if (error()) {
      <p class="text-danger" role="alert">{{ error() | transloco }}</p>
    }
  </form>
</ct-lib-modal>

<ng-template #invoiceBillingFooter>
  <app-button variant="white-grey" [disabled]="busy()" (click)="close()">
    {{
      'company-tool.views.settings.company.payment.invoice-billing.cancel'
        | transloco
    }}
  </app-button>
  <app-button [loading]="busy()" (click)="submit()">
    {{
      'company-tool.views.settings.company.payment.invoice-billing.save'
        | transloco
    }}
  </app-button>
</ng-template>
